import AsyncComponent from 'erxes-ui/lib/components/AsyncComponent';

export default AsyncComponent;
